// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".32f76fb307c0f3183ae63de16e1c3f3b.js";
};